import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'labels',
            name: 'label',
            class: 'Modules\\Site\\Entities\\Label'
        }
    }
}